import React from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';

const AboutUs = () => {
    const { t } = useTranslation();

    return (
        <div class="page-padding-info">
            <div class="text-page-container">
                <h1 class="text-page-title">{t("aboutUs.aboutUsTitle")}</h1>
                    <p>  
                        &nbsp;
                        {t("aboutUs.aboutUsText1")}
                        <br></br>
                        <br></br>
                        &nbsp;
                        {t("aboutUs.aboutUsText2")}
                        <br></br>
                        <br></br>
                        &nbsp;
                        {t("aboutUs.aboutUsText3")}
                        <br></br>
                        <br></br>
                        &nbsp;
                        {t("aboutUs.aboutUsText4")}
                    </p>
                    
                    <p>
                        &nbsp;
                        <strong><u><a href="/products" class="no-link-color">{t("aboutUs.exploreOurCollection")}</a></u></strong> {t("aboutUs.aboutUsText5")}
                    </p>
            </div>
        </div>
    );
}

export default AboutUs;